export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/dynaagency",
  facebook:  "https://www.facebook.com/share/18eW3fK91k/?mibextid=wwXIfr",
  linkedin:  "",
  x:         "",
  whatsapp:  "https://wa.me/972546497186",
} as const;
